// frontend/src/services/auth.service.js

import api from './api';

const authService = {
  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        // ✅ Sauvegarder l'expiration de la session
        if (response.data.session?.expiresAt) {
          localStorage.setItem('sessionExpires', response.data.session.expiresAt);
        }
      }
      return response.data;
    } catch (error) {
      // ✅ Gérer le message de session déjà active (403)
      if (error.response?.status === 403) {
        throw new Error(error.response.data.message || 'Une session est déjà active pour ce compte');
      }
      throw error;
    }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Erreur logout:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('sessionExpires');
    }
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  changePasswordFirstLogin: async (newPassword) => {
    const response = await api.post('/auth/change-password-first-login', {
      newPassword,
    });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token, password) => {
    const response = await api.post(`/auth/reset-password/${token}`, {
      password,
    });
    return response.data;
  },
};

export default authService;